import { render, staticRenderFns } from "./RecursosDeGlosaPorCompetencia.vue?vue&type=template&id=1f2b2647"
import script from "./RecursosDeGlosaPorCompetencia.vue?vue&type=script&lang=js"
export * from "./RecursosDeGlosaPorCompetencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports